export const primaryNavigation = [
  { label: "Home", to: "/", match: "exact" },
  { label: "Work", to: "/work", match: "section" },
  { label: "Leadership", to: "/leadership", match: "section" },
  { label: "About", to: "/about", match: "section" },
];

export const getNavigationState = (pathname, item) => {
  const isCurrent = pathname === item.to;
  const isSectionActive =
    item.match === "section" && pathname.startsWith(`${item.to}/`);

  return {
    isActive: isCurrent || isSectionActive,
    isCurrent,
  };
};
